import React from "react";
import { View, ScrollView, Platform } from "react-native";
import tw from "twrnc";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useFrame } from "@/components/layout/FrameContext";

const NO_INSETS = { top: 0, right: 0, bottom: 0, left: 0 };

const AppContainer = ({
  children,
  scrollable = false,
  style,
  contentContainerStyle,
  ...props
}) => {
  const deviceInsets = useSafeAreaInsets();
  // Inside a wide-layout frame the frame keeps clear of the notch and home indicator.
  const insets = useFrame() ? NO_INSETS : deviceInsets;

  const containerStyles = tw.style("flex-1 bg-white", {
    paddingTop: insets.top,
    paddingBottom: insets.bottom,
    paddingLeft: insets.left,
    paddingRight: insets.right,
    // Web-specific styles to ensure full viewport height
    ...(Platform.OS === "web" && {
      maxHeight: "100vh",
      height: "100%",
    }),
  });

  if (scrollable) {
    return (
      <ScrollView
        style={[containerStyles, style]}
        contentContainerStyle={[tw`px-5 py-4`, contentContainerStyle]}
        showsVerticalScrollIndicator={false}
        {...props}
      >
        {children}
      </ScrollView>
    );
  }

  return (
    <View style={[containerStyles, style]} {...props}>
      {children}
    </View>
  );
};

export default AppContainer;
